/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'
import './Footer.css'

/*
 * Props
 * 
 * backPressed
 * nextPressed
 * showLoading
 * showWaiting
 * nextDisabled
 * showProcessing
 * showErrors
 */

export default class Footer extends Component {

    needHideBackBtn() {
        return !this.props.showWaiting || this.props.showProcessing || this.props.showErrors
    }

    needHideNextBtn() {
        return this.props.showWaiting || this.props.showProcessing || this.props.showErrors
    }

    render() {
        const backStyles = this.needHideBackBtn() ? { display: 'none' } : null
        const nextStyles = this.needHideNextBtn() ? { display: 'none' } : null
        const loadingStyles = this.props.showLoading ? null : { display: 'none' }
        const nextTextStyles = this.props.showLoading ? { display: 'none' } : null

        const hideClass = this.props.show ? '' : 'hide'

        return (
            <div className={`footer ${hideClass}`}>
                <div className="trace-container">
                    <button style={backStyles} className="TRCButton" onClick={this.props.backPressed}>
                        <i className="trace-icon arrow-forward-white rotate180" />
                        Edit Info
                    </button>
                    <button
                        disabled={this.props.nextDisabled}
                        style={nextStyles}
                        className="TRCButton next-button"
                        onClick={this.props.nextPressed}>
                        <i style={loadingStyles} className="trace-icon centered loader-white-small rotating" />
                        <span style={nextTextStyles}>
                            Save Info
                            <i className="trace-icon arrow-forward-white after" />
                        </span>
                    </button>
                </div>
            </div>
        )
    }
}
